// @flow

import * as React from 'react';

import { type MailboxProduct, selectCartCurrency } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { ListRow } from '../../ListRow';

import Price from './components/Rows/Price';

export type Props = {
  product: MailboxProduct,
};

export default function MailboxOptionRenew({
  // $FlowFixMe[incompatible-use] basePrice and mailboxType are missing into the MailboxProduct type
  product: { basePrice, unitPrice, quantity, mailboxType },
}: Props): React.MixedElement {
  const { __, formatPrice } = useTranslator();
  const currency = useAppSelector(selectCartCurrency);

  const label = `${quantity} ${
    mailboxType === 'standard' ? __('Mailbox 3 GB') : __('Mailbox 50 GB')
  }`;
  // XXX: what if unitPrice is undefined or may be fix MailboxProduct type?
  const detail = __('%(unitPrice)s / month / additional mailbox', {
    unitPrice: unitPrice ? formatPrice(unitPrice, currency) : '',
  });

  return (
    <ListRow
      title={label}
      options={[detail]}
      optionsArrow={false}
      price={<Price price={basePrice} />}
    />
  );
}
